import React, { useContext, useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Carousel, CarouselItem } from "react-bootstrap";
import { ConfigurationContext, TargetsContext, TestsContext, ApplicationStateContext } from "../../contexts";
import { UseTesting } from "../../hooks";
import { ShadowBox, Stat } from "../common";
import { Test } from "./Test.js";
import { Status } from "./Status.js";
import { Video } from "./Video";

/**
 * GlobalTesting component.
 *
 * Handle the test running and display of real time results.
 */
export const GlobalTesting = () => {
  const targets = useContext(TargetsContext);
  const { applicationState } = useContext(ApplicationStateContext);
  const { tests, dispatch } = useContext(TestsContext);
  const [activeSlide, setActiveSlide] = useState(0);
  const { averageLatency, minimumLatency, maximumLatency } = tests;
  const navigate = useNavigate();
  const { globalTestTime, globalTestLimit } = useContext(ConfigurationContext);

  /** Function: Navigate to the results view.
   */
  const onDone = useCallback(() => {
    // Navigate to results view after a short time.
    setTimeout(() => {
      navigate("/global-tests");
    }, 3000);
  }, [navigate]);

  const { start, count } = UseTesting({ min: 0, max: targets.length - 1 }, globalTestTime, globalTestLimit, onDone);

  /** Effect: Set the active slide whenever the count changes.
   */
  useEffect(() => {
    setActiveSlide(count);
  }, [count]);

  /** Effect: Reload the page if ads are showing.
   */
  useEffect(() => {
    // Reload the page if we're showing ads.
    if (applicationState.loadedAds) {
      window.location.reload(false);
      return;
    }
  });

  /** Effect: Start the testing.
   */
  useEffect(() => {
    // Check for ads.
    if (applicationState.loadedAds) {
      return;
    }

    const onStart = () => {
      // Reset the tests data and stats.
      dispatch({ type: "reset" });

      // Start the testing in 3 seconds to match the video intro.
      setTimeout(() => {
        start();
      }, 3000);
    };

    onStart();
  }, [applicationState.loadedAds, dispatch, start]);

  /** Function: Map all the test data to the carousel.
   */
  const mapper = () => {
    var ar = targets.map((item, index) => (
      <CarouselItem key={index}>
        <Test key={index} index={index} location={"xxx"} show={true} />
      </CarouselItem>
    ));

    return ar; //.reverse();
  };

  // Rendering.

  // Don't show anything until there are no ads via a page reload.
  if (applicationState.loadedAds) {
    return null;
  }

  return (
    <>
      <div className='my-4'>
        <Carousel indicators={false} controls={false} activeIndex={activeSlide}>
          {mapper()}
        </Carousel>
      </div>
      <Row className='my-4'>
        <Col className='col-8'>
          <Video></Video>
          <Status></Status>
        </Col>
        <Col className='align-self-center'>
          <ShadowBox className='mb-3'>
            <Stat title='Average Latency' value={averageLatency} />
          </ShadowBox>

          <ShadowBox className='mb-3'>
            <Stat title='Minimum Latency' value={minimumLatency} />
          </ShadowBox>

          <ShadowBox className='mb-3'>
            <Stat title='Maximum Latency' value={maximumLatency} />
          </ShadowBox>
        </Col>
      </Row>
    </>
  );
};
